import React, { useContext, useEffect, useState } from "react"
import { FeatureTypeReferenceSimple } from "../../../../../../api/generated/QuadriConfigurationApi"
import { FCFeatureType } from "../../../../../../api/types"
import { FeatureCatalogContext } from "../../../../../../features/FeatureCatalogViewer/FeatureCatalogProvider"
import "./Inheritance.css"
import Canvas from "./Canvas"
import { Spinner } from "@trimbleinc/modus-react-bootstrap"

const Inheritance = () => {
  const [properties, setProperties] = useState(null as FCFeatureType | null)
  const [canvasList, setCanvasList] = useState([] as FeatureTypeReferenceSimple[])

  const context = useContext(FeatureCatalogContext)

  useEffect(() => {
    if (context.elementDetails !== null && "inheritanceChain" in context.elementDetails) {
      setProperties(context.elementDetails)
      if (context.elementDetails.inheritanceChain !== undefined) {
        const list = context.elementDetails.inheritanceChain.map((ele: any) => ele)
        list.reverse() // This is needed for the visuals to appear in correct order
        list.push({ featureTypeId: context.elementDetails.id, featureTypeName: context.elementDetails.name })
        setCanvasList(list)
      }
    }
  }, [context.elementDetails])

  return (
    <div className="inheritanceContainer">
      <h1 className="card-subtitle-2 header" id="headerInPanel">
        INHERITANCE
      </h1>
      <div className="canvasContainer">
        {context.loading ? (
          <Spinner className="spinner" animation="border" role="status" variant="primary" />
        ) : (
          properties !== null && <Canvas inheritance={canvasList} featureTypeName={properties?.name} />
        )}
      </div>
    </div>
  )
}

export default Inheritance
